import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

/**
 * A secure pipe to render HTML strings while allowing specific safe attributes 
 * like 'style' (for rich text colors) and 'target' (for links), 
 * while absolutely blocking scripts and other XSS vectors.
 */
@Pipe({
    name: 'safeHtml',
    standalone: true
})
export class SafeHtmlPipe implements PipeTransform {
    private readonly sanitizer = inject(DomSanitizer);

    transform(value: string | null | undefined): SafeHtml {
        if (!value) return '';

        // Sanitize the HTML using DOMPurify
        // We allow 'style' attribute for rich text colors/formatting
        // and 'target' for external links.
        const sanitizedHtml = DOMPurify.sanitize(value, {
            ADD_ATTR: ['target', 'style'],
            FORBID_TAGS: ['script', 'iframe', 'form', 'object', 'embed'],
            FORBID_ATTR: ['onerror', 'onclick', 'onload']
        });

        // Use bypassSecurityTrustHtml ONLY on the purified string
        return this.sanitizer.bypassSecurityTrustHtml(sanitizedHtml);
    }
}